"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatActionApiErrorMessages;

var _getErrorMessages = _interopRequireDefault(require("./get-error-messages"));

function formatActionApiErrorMessages(action) {
  var payload = action.payload;
  var messages = (0, _getErrorMessages.default)(payload);
  var message = '';

  if (messages.length) {
    var formatted = messages.map(function (msg) {
      if (msg.message) {
        return msg.message;
      }

      return msg;
    }).join(', ');
    message += "".concat(formatted);
  }

  return message.trim();
}